module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append(" <div class=\"col-md-12 subsection nopadding-r\">\r\n    <label class=\"prop-sublabel label-65\">Aggreg.</label> \r\n    <div>\r\n        <select  class=\"columnSpecific\" name=\"aggregation\" id=\"columnAggregate\" >\r\n            <option value=\"group\">Group</option>\r\n            <option value=\"count\">Count</option>\r\n            <option value=\"sum\">Sum</option>\r\n            <option value=\"avg\">Average</option>\r\n            <option value=\"min\">Minimum</option>\r\n            <option value=\"max\">Maximum</option>\r\n            <option value=\"stdev\">Standard Deviation</option>\r\n            <option value=\"stdevp\">Population Standard Deviation</option>\r\n            <option value=\"var\">Variance</option>\r\n            <option value=\"varp\">Population Variance</option>\r\n        </select>\r\n    </div>\r\n</div>")
  }
  return __output;

}